export default __webpack_public_path__ + "static/media/s-squiggle-128.42a16f59.svg";